import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_FinancialAgreement = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_FinancialAgreement' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Diagnosis:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Admission Date:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDiagnosis' name='txtDiagnosis' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName' name='txtClinicianName' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Title:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Discharge Date:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtTitle' name='txtTitle' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDischargeDate' name='txtDischargeDate' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>PLACEMENT:</span></p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPlacement' id='chkPlacement' className='add-only' value='1' /> OUTPATIENT
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPlacement1' id='chkPlacement1' className='add-only' value='1' /> INTERVENTION
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPlacement2' id='chkPlacement2' className='add-only' value='1' /> PREVENTION
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h4>SESSIONS NEEDED:</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># OF INDIVIDUAL</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'># OF GROUP</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson' name='txtContactPerson' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h4>Employment Information:</h4></p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Client Employer:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact#:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientEmployer' name='txtClientEmployer' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContact' name='txtContact' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> If unemployed</span>
                    <span className='small'>(explain your source of income):</span>
                    <textarea id='txtParentSpace' name='txtParentSpace' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Insurance Carrier:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Policy#:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPolicy' name='txtPolicy' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>Financial Assessment:</span></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <b>Gross Household Income</b>
                        </td>
                        <td className='w-375'>
                            <b>Total Dependents</b> &nbsp;
                            <input type='text' id='txtHousehold' name='txtHousehold' className='add-only w-150 custom-add-only' /> X $2,000
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>$ <input type='text' id='txtHousehold2' name='txtHousehold2' className='add-only w-250 custom-add-only' /> (monthly)
                        </td>
                        <td className='w-375'>$ <input type='text' id='txtHousehold1' name='txtHousehold1' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h3>Program Fees:</h3></p>


                <p className='w-750'><h4>Outpatient services, Prevention, and Aftercare</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Assessments</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual Counseling</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>$65.00
                        </td>
                        <td className='w-375'>$50.00
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Group Sessions</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual session Cancellation/Reschedule:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>$25.00
                        </td>
                        <td className='w-375'>$10.00
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance testing</span>
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>$10.00
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>Fees are DUE Upon Rendered Services</b> via *Cash/Cashier's Checks or Money Orders, ONLY* (Fees are required at each session. No payment No services * No Exceptions)</p>


                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Number of Family Members in Household:</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Annual Family Income:</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Source of Income:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtFamilyMembers' name='txtFamilyMembers' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtAnnualFamily' name='txtAnnualFamily' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtSourceIncome' name='txtSourceIncome' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>Based on the information received, the family/individuals eligibility is based on &nbsp;
                        <input type='text' id='txtFamily' name='txtFamily' className='add-only w-150 custom-add-only' /> % of the federal poverty guideline.
                        (Note: DUI program is a self-pay program, sliding scale fee does not apply).</b>
                </p>

                <p className='w-750'>
                    <b>The undersigned whether signing as responsible party or as a client in the DUI program in consideration of the services to be rendered to the client unconditionally guarantee(s) full payment of charges of Northwest Behavioral Health Services, Inc. Based on the above financial evaluation. I agree to pay Northwest Behavioral Health Services, Inc. the total amount of charges as listed for the program fees. The information provided above is complete and accurate to the best of my knowledge and I authorize Northwest Behavioral Health Services, Inc. financial responsibility notification form.</b>
                </p>

                <p className='w-750'>
                    <b>I hereby attest and certify that the above information is correct to the best of my knowledge</b>
                </p>

            </div>
        </form>

    )
}

